import * as React from "react";
import ThankYouEmail from "../../public/ThankYouEmail";
export default function ThankYouEmailSecure() {
    return (<ThankYouEmail />);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/EmailOptOutSecure/ThankYouEmailSecure.tsx